import { useAppDispatch } from '@common-reducers/hooks/store.hook';
import { LinkPreview, MessageAsset } from '@bt-common/schemas/bt/user-message';
import {
    loadTemplateData
} from '@common/reducers/ScheduledMessageEditorReducer';
import { Poll } from '@extension/context/content/components/add-scheduled-message-button/schedule-message-types';
import { useEffect } from 'react';
import MessageEditorControlled from './message-editor-controlled';
import GoogleTranslateErrorBoundary from '../google-translate-error-boundary/google-translate-error-boundary';

type MessageEditorPreviewProps = {
    // Template data to display
    template?: {
        message?: string;
        isPoll?: boolean;
        poll?: Poll;
        // Reading the persisted Template.asset — bt-common's MessageAsset
        // (wider than the editor's input-form Asset). #41.
        asset?: MessageAsset;
        imageId?: string;
        sendLinkPreview?: boolean;
        linkPreview?: LinkPreview;
        templateId?: string;
        _id?: string;
        [key: string]: any; // Allow other template properties
    };
    
    // Context for the editor
    editorContext: 'scheduleMessage' | 'scheduleCampaign';
    
    // Always in preview mode for read-only contexts
    isPreview?: boolean;
}

export default function MessageEditorPreview({
    template,
    editorContext,
    isPreview = true,
}: MessageEditorPreviewProps) {
    const dispatch = useAppDispatch();

    // Initialize Redux state with template data when component mounts
    useEffect(() => {
        if (template) {
            dispatch(loadTemplateData(template));
        }
    }, [dispatch, template]);

    // Note: Not cleaning up Redux state automatically to avoid interference 
    // with other instances. Parent components can call resetScheduledMessageEditor() 
    // if needed when closing dialogs.

    return (
        <GoogleTranslateErrorBoundary>
            <MessageEditorControlled
                isPreview={isPreview}
                editorContext={editorContext}
            />
        </GoogleTranslateErrorBoundary>
    );
} 